import { render } from "./clubs.vue?vue&type=template&id=f07904ea"
import script from "./clubs.vue?vue&type=script&lang=js"
export * from "./clubs.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__